var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1346,
    height: 390,
    viewBox: "0 0 1346 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 99.2931C63.4837 198.08 150.218 279.82 256.329 328.103C317.733 356.043 401.774 368.24 462.029 331.551C476.263 322.883 491.084 312.601 494.751 295.26C496.425 287.348 496.111 278.909 488.571 274.394C474.723 266.101 459.066 270.203 445.395 276.571C436.005 280.944 422.594 285.346 417.853 295.442C412.648 306.524 409.796 319.788 408.127 331.823C403.968 361.802 435.264 375.272 459.847 380.18C530.17 394.218 605.285 384.69 674.363 368.748C709.663 360.602 745.46 352.036 777.44 334.454C814.724 313.956 851.148 283.86 877.609 250.442C918.17 199.216 949.527 126.125 932.328 60.0996C927.772 42.6095 921.628 24.0661 906.15 13.1945C893.993 4.65545 878.076 3.38315 863.701 3.03322C818.392 1.93018 779.845 28.3547 767.896 73.2549C763.752 88.8269 759.528 104.063 761.261 120.341C763.308 139.571 770.25 157.264 778.895 174.414C804.756 225.72 855.255 256.928 905.423 281.47C974.408 315.217 1055.25 331.19 1131.57 335.361C1202.17 339.219 1272.42 334.454 1343 334.454",
    stroke: "#3EAB36",
    strokeOpacity: 0.5,
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "20 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.769b52de4a44d1b5ba40deff61758a8a.svg";
export { ForwardRef as ReactComponent };